(function() {
  'use strict';

  function UserFieldsReorderController(UserFields,
                            Notify, $translate, Utils, BLUEPRINT_TYPES) {
    var ctrl = this;
    ctrl.loaded = false;
    ctrl.reorderInfo = $translate.instant(
      'Drag and drop user fields in the list below in order to re-order them. ' +
      'The order you set here will determine the order these user fields are shown ' +
      'on the user\'s profile and few other places. The order is saved automatically. ' +
      'When you are done, click the <strong>Done</strong> button.');

    Utils.setPageTitle('Reorder user fields');

    ctrl.options = {
      trackBy: 'doc._id',
      stateMapping: _.keyBy(_.map(BLUEPRINT_TYPES, function(item) {
        return { id: item.name, name: item.label };
      }), 'id'),
      stateField: 'doc.fieldType'
    };

    UserFields.findAll({ cached: false })
      .then(function(items) {
        ctrl.userFields = _.chain(items)
                              .sortBy(function(item) {
                                return item.doc.order;
                              })
                              .value();

        ctrl.loaded = true;
      });

    ctrl.actions = [
      {
        label: $translate.instant('Done'),
        icon: 'icon-save',
        route: ['/user-fields'],
        klass: 'btn-success'
      }
    ];

    ctrl.reorder = function(evt) {
      evt.models.forEach(function(model, index) {
        var order = index + 1;
        if (model.doc.order === order) {
          return;
        }
        model.doc.order = order;
        UserFields.updateOrder(model.doc._id, order)
          .then(function(data) { model.doc._rev = data.rev; })
          .catch(Utils.showError);
      });
      Notify.success('Order successfully updated!', 'Success');
    };
  }

  UserFieldsReorderController.$inject = ['UserFieldsService',
    'NotifyService', '$translate', 'UtilsService', 'BLUEPRINT_TYPES'];

  angular.module('component.userFields')
    .component('userFieldsReorder', {
      templateUrl: 'app/components/user-fields/list-reorder.html',
      controller: UserFieldsReorderController,
      controllerAs: 'userFieldsReorderCtrl'
    });
})();
